import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';

import { QUESTION_TYPES } from '@api/instant_survey';
import { GATES } from '@constants';
import { OverlayTriggerTooltip } from '@utilities';

import styles from './_index.module.scss';

const additionalQuestionTypes = [
  QUESTION_TYPES.INSTRUCTIONS,
  QUESTION_TYPES['RANK-DRAGDROP'],
  QUESTION_TYPES['TABLE-RADIO'],
];
const commonQuestionTypes = [QUESTION_TYPES.CHECKBOX, QUESTION_TYPES.RADIO, QUESTION_TYPES.ESSAY];

const Sidebar = ({ isTurfSurvey, isVideoSurvey, onSelectQuestionType, question }) => {
  const { client } = useStatsigClient();
  const canContinuousSum = client.checkGate(GATES.QUESTION_TYPE_CONT_SUM);
  const canMaxDiff = client.checkGate(GATES.QUESTION_TYPE_MAX_DIFF);
  const canNumeric = client.checkGate(GATES.QUESTION_TYPE_NUMERIC);

  const renderQuestionTypeButton = (type) => {
    return (
      <OverlayTriggerTooltip
        content={type.value === question.type ? null : type.description}
        placement="right"
      >
        <button
          aria-pressed={type.value === question.type}
          className={classNames({
            [styles['is-active']]: type.value === question.type,
          })}
          data-testid={type.value}
          onClick={() => onSelectQuestionType(type.value)}
        >
          {type.icon}
          <span>{type.name}</span>
        </button>
      </OverlayTriggerTooltip>
    );
  };

  return (
    <div className={styles['sidebar']}>
      <h4>Common Question Types</h4>
      {isVideoSurvey ? (
        <ul>
          <li key={QUESTION_TYPES.VIDEO.value}>{renderQuestionTypeButton(QUESTION_TYPES.VIDEO)}</li>
        </ul>
      ) : (
        <>
          <ul>
            {commonQuestionTypes.map((type) => (
              <li key={type.value}>{renderQuestionTypeButton(type)}</li>
            ))}
          </ul>
          <hr />
          <h4>Additional Question Types</h4>
          <ul>
            {additionalQuestionTypes.map((type) => (
              <li key={type.value}>{renderQuestionTypeButton(type)}</li>
            ))}
            {canContinuousSum && <li>{renderQuestionTypeButton(QUESTION_TYPES.CONTSUM)}</li>}
            {isTurfSurvey && <li>{renderQuestionTypeButton(QUESTION_TYPES.TURF)}</li>}
            {canMaxDiff && <li>{renderQuestionTypeButton(QUESTION_TYPES.MAX_DIFF)}</li>}
            {canNumeric && <li>{renderQuestionTypeButton(QUESTION_TYPES.NUMERIC)}</li>}
          </ul>
        </>
      )}
    </div>
  );
};

Sidebar.propTypes = {
  isTurfSurvey: PropTypes.bool.isRequired,
  isVideoSurvey: PropTypes.bool.isRequired,
  onSelectQuestionType: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
};

export default Sidebar;
